// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"58a8fa30","703":"8e931eb3"}[chunkId] + ".chunk.js";
};